import React, { useState, useEffect, memo } from 'react';
import { Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import MemberFeedItem from './MemberFeedItem';


const SCHEMA = 'united_states_of_america';
const TABLE = 'all_member_votes';

const APIMemberVotePull = memo(({ bio_guide_id, limit = 3 }) => {
  const { t } = useTranslation('common');
  const [voteInfo, setVoteInfo] = useState([]);
  const [loading, setLoading] = useState(true);
  const apiKey = process.env.REACT_APP_API_KEY;

  useEffect(() => {
    let cancelled = false;

    const fetchVoteInfo = async () => {
      setLoading(true);

      try {
        const response = await fetch(
          `https://api.govglance.org/posts/recent` +
            `?limit=${limit}` +
            `&skip=0` +
            `&schema=${SCHEMA}` +
            `&table=${TABLE}` +
            `&order_by=created_at` +
            `&filter_column=bio_guide_id` +
            `&filter_string=${bio_guide_id}`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${apiKey}`,
            },
          }
        );

        const data = await response.json();
        if (cancelled) return;
        setVoteInfo(Array.isArray(data) ? data : []);
      } catch (error) {
        if (cancelled) return;
        console.error('Error fetching vote info:', error);
        setVoteInfo([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchVoteInfo();

    return () => {
      cancelled = true;
    };
  }, [bio_guide_id, limit, apiKey]);

  if (loading) {
    return <Spinner id="spinner" animation="grow" variant="light" />;
  }

  if (voteInfo.length === 0) {
    return <p className="member-detail-text">{t('common:noDataAvailable', 'No data available.')}</p>;
  }

  return (
    <div className="member-feed-grid">
      {voteInfo.map((vote) => (
        <MemberFeedItem
          key={vote.roll_call_number}
          // Vote records are keyed by roll_call_number, but FeedItem builds
          // its detail route and share link from item.id. Normalize here so
          // the routing stays identical to the old handleDetailsClick.
          item={{ ...vote, id: vote.roll_call_number }}
          schema={SCHEMA}
          table={TABLE}
          feedName="Votes"
          branch="Legislative"
          topic="Member Votes"
          buttonName={t('common:document', 'Document')}
          variant="default"
          bodyExtra={
            <>
              <div>{t('common:statusLabel', 'Status: {{status}}', { status: vote.status })}</div>
              <div>{t('common:voteLabel', 'Vote: {{vote}}', { vote: vote.vote })}</div>
            </>
          }
        />
      ))}
    </div>
  );
});

export default APIMemberVotePull;